import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { LOCALSTORAGE_AUTHS_KEY } from "@/routes/external/new_utility_connection";
import { DateTime } from "luxon";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
export function getLocalStorageAuth(connType, utilityCode, create = false) {
  const allAuths = JSON.parse(
    localStorage.getItem(LOCALSTORAGE_AUTHS_KEY) || "[]",
  ) as object[];
  let currentAuth = allAuths.find(
    (auth: any) =>
      auth.connType === connType && auth.utilityCode === utilityCode,
  ) as any;
  if (!currentAuth && create) {
    currentAuth = {
      connType,
      utilityCode,
      status: "STARTED",
      started_on: DateTime.now().toISOTime(),
      updated_on: DateTime.now().toISOTime(),
    };
  }
  return currentAuth;
}
export function updateLocalStorageAuth(connType, utilityCode, obj) {
  const allAuths = JSON.parse(
    localStorage.getItem(LOCALSTORAGE_AUTHS_KEY) || "[]",
  ) as object[];
  let found = false;
  let newAllAuths = allAuths.map((auth: any) => {
    if (auth.connType === connType && auth.utilityCode === utilityCode) {
      found = true;
      return { ...auth, ...obj };
    }
    return auth;
  });

  if (!found) {
    newAllAuths.push({ connType, utilityCode, ...obj });
  }
  newAllAuths = newAllAuths.filter((auth) => auth.status !== "SUCCESS");

  localStorage.setItem(LOCALSTORAGE_AUTHS_KEY, JSON.stringify(newAllAuths));
}
